import { VideoFeedback } from "@/enums/enums";
import { i18n } from "@/i18n";

function GenerateYouTubeVideoURL(videoId: string): string {
  const videoUrl = `https://www.youtube.com/embed/${videoId}?rel=0`;
  return videoUrl;
}
export function GetYoutubeUrlFromPageName(urlName: string) {
  let youtubeUrlList = [];
  const salary = {
    name: i18n.t("youtube_List.Salary"),
    url: GenerateYouTubeVideoURL("HE_c5EbksRA"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const socialSecurity = {
    name: i18n.t("youtube_List.Social_Security"),
    url: GenerateYouTubeVideoURL("SjlPxwuxzZA"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const accountingRecord = {
    name: i18n.t("youtube_List.Accounting_Record"),
    url: GenerateYouTubeVideoURL("cqhqDO8_7OU"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const importEmployee = {
    name: i18n.t("youtube_List.Import_Employee"),
    url: GenerateYouTubeVideoURL("nAhXnTp0NZk"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const resignEmployee = {
    name: i18n.t("youtube_List.Resign_Employee"),
    url: GenerateYouTubeVideoURL("HqhXygRhrvo"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const storeEmployee = {
    name: i18n.t("youtube_List.Store_Employee"),
    url: GenerateYouTubeVideoURL("hz8vgF1TD40"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const department = {
    name: i18n.t("youtube_List.Department"),
    url: GenerateYouTubeVideoURL("tGPEONfKnwY"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const revenue = {
    name: i18n.t("youtube_List.Revenu"),
    url: GenerateYouTubeVideoURL("GW_Vw6MUs2Q"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };

  switch (urlName) {
    case "salary":
      youtubeUrlList = [salary];
      break;
    case "salarySummary":
      youtubeUrlList = [salary];
      break;
    case "salaryDetail":
      youtubeUrlList = [salary];
      break;
    case "salaryCreate":
      youtubeUrlList = [salary];
      break;
    case "salaryEdit":
      youtubeUrlList = [salary];
      break;
    case "setting":
      youtubeUrlList = [socialSecurity, accountingRecord];
      break;
    case "employee":
      youtubeUrlList = [importEmployee, resignEmployee, storeEmployee];
      break;
    case "employeeDetail":
      youtubeUrlList = [importEmployee, resignEmployee, storeEmployee];
      break;
    case "department":
      youtubeUrlList = [department];
      break;
    case "departmentDetail":
      youtubeUrlList = [department];
      break;
    case "revenue":
      youtubeUrlList = [revenue];
      break;
    default:
      youtubeUrlList = [
        {
          name: i18n.t("youtube_List.Peak_Payroll_Overview"),
          url: GenerateYouTubeVideoURL("4YvHP_g-iy8"),
          isShow: false,
          isSendFeedback: VideoFeedback.None,
        },
        {
          name: i18n.t("youtube_List.Setting_Access_To_Peak_Payroll"),
          url: GenerateYouTubeVideoURL("BEkzw5wx3LI"),
          isShow: false,
          isSendFeedback: VideoFeedback.None,
        },
      ];
      break;
  }

  return youtubeUrlList;
}
